import { useEffect, useState } from 'react';
import { Platform, Pressable, View } from 'react-native';
import { colors, newerVersionOnline } from '@hogar/shared';
import { Txt, useT } from './ui';

const CHECK_MS = 5 * 60_000;

/**
 * In a browser, a page open since before an update keeps running the old version. This checks
 * every few minutes and when the page comes back to the front, and offers a one-tap update.
 * (The installed iPhone and Android apps get updates another way, at milestone 6.)
 */
export function UpdateBanner() {
  const { t } = useT();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const check = () => void newerVersionOnline('owner').then((newer) => newer && setReady(true));
    const onVisible = () => document.visibilityState === 'visible' && check();
    check();
    const timer = setInterval(check, CHECK_MS);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
  if (!ready) return null;
  return (
    <View style={{ position: 'absolute', left: 12, right: 12, bottom: 84, flexDirection: 'row', alignItems: 'center', gap: 12, padding: 12, paddingLeft: 16, borderRadius: 14, backgroundColor: colors.text }}>
      <Txt color={colors.white} style={{ flex: 1 }}>
        {t('updateReady')}
      </Txt>
      <Pressable onPress={() => window.location.reload()} style={{ paddingVertical: 8, paddingHorizontal: 14, borderRadius: 10, backgroundColor: colors.primary }}>
        <Txt weight="semibold" color={colors.white}>
          {t('updateNow')}
        </Txt>
      </Pressable>
    </View>
  );
}
